<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.5 43L35.5 48H42.5L43.5 43L47.5 42L51.5 44L56.5 39L53.5 35L55.5 31L60.5 29V22L55.5 21L54.5 17L56.5 13L51.5 8L47.5 11L44.5 9L42.5 4H34.5L33.5 9L29.5 10L25.5 8L20.5 13L23.5 17L21.5 21L16.5 23V30L21.5 31"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.5006 26.0003C46.5006 32.4006 41.1671 34.0006 38.5003 34.0006C35.8335 34.0006 30.5 32.4006 30.5 26.0003C30.5 19.6001 35.8335 18 38.5003 18C41.1671 18 46.5006 19.6001 46.5006 26.0003Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6818 36H14.3182L13.7727 38.7273L11.5909 39.2727L9.40909 38.1818L6.68182 40.9091L8.31818 43.0909L7.22727 45.2727L4.5 46.3636V50.1818L7.22727 50.7273L7.77273 52.9091L6.68182 55.6364L9.40909 57.8182L11.5909 56.1818L13.7727 57.2727L14.8636 60H18.6818L19.2273 57.2727L21.4091 56.7273L23.5909 57.8182L26.3182 55.0909L24.6818 52.9091L25.7727 50.7273L28.5 49.6364V45.8182L25.7727 45.2727L25.2273 43.0909L26.3182 40.9091L23.5909 38.1818L21.4091 39.8182L19.7727 38.7273L18.6818 36Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.863 48.0004C20.863 51.4913 17.9539 52.364 16.4994 52.364C15.0448 52.364 12.1357 51.4913 12.1357 48.0004C12.1357 44.5094 15.0448 43.6367 16.4994 43.6367C17.9539 43.6367 20.863 44.5094 20.863 48.0004Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
